/** PRR-funded log.AI project page copy. */
export const LOG_AI_PT = {
  seo: {
    title: 'Projeto log.AI',
    description:
      'Informação sobre o projeto log.AI da LOG.OSCON, apoiado pelo Plano de Recuperação e Resiliência e financiado pela União Europeia através do NextGenerationEU.',
  },
  title: 'Projeto log.AI',
  lead:
    'A LOG.OSCON está a executar o projeto log.AI, uma iniciativa de transformação digital destinada a integrar soluções de inteligência artificial nos processos internos e nas atividades de negócio da empresa.',
  financing: {
    label: 'Financiamento do projeto',
    alt:
      'PRR — Plano de Recuperação e Resiliência, República Portuguesa e Financiado pela União Europeia NextGenerationEU',
    text:
      'Projeto apoiado pelo Plano de Recuperação e Resiliência e financiado pela União Europeia através do NextGenerationEU.',
  },
  identification: {
    title: 'Identificação do projeto',
    items: [
      { label: 'Beneficiário', value: 'LOG.OSCON, LDA' },
      { label: 'Número do projeto', value: '25286' },
      { label: 'Aviso', value: '03/C05-i14.01/2025' },
      { label: 'Investimento', value: 'C05-i14.01\nInovação Empresarial' },
      { label: 'Investimento elegível', value: '148.406,80 €' },
      { label: 'Apoio financeiro', value: '111.305,10 €' },
      { label: 'Taxa de financiamento', value: '75%' },
      { label: 'Período de execução', value: '01.01.2025\n31.12.2026' },
      { label: 'Entidade gestora', value: 'Banco Português de Fomento' },
    ],
  },
  description: {
    title: 'Descrição',
    paragraphs: [
      'O projeto log.AI pretende acelerar a adoção de inteligência artificial na LOG.OSCON, automatizando tarefas, melhorando o tratamento e a utilização da informação e reforçando a eficiência dos processos operacionais, comerciais e administrativos.',
      'A iniciativa inclui a implementação de soluções de extração inteligente de dados e de agentes de inteligência artificial integrados nos processos e sistemas da empresa, acompanhada pela capacitação das equipas para a utilização das novas ferramentas.',
    ],
  },
  objectives: {
    title: 'Objetivos',
    items: [
      'Digitalizar e automatizar processos internos.',
      'Reduzir o esforço associado a tarefas manuais e repetitivas.',
      'Implementar soluções de extração e tratamento inteligente de dados.',
      'Desenvolver agentes de inteligência artificial de apoio às áreas operacionais, comerciais e administrativas.',
      'Melhorar a produtividade, a rastreabilidade da informação e a capacidade de resposta da organização.',
      'Reforçar as competências internas na utilização e gestão de soluções de inteligência artificial.',
    ],
  },
  workstreams: {
    title: 'Áreas de intervenção',
    items: [
      {
        title: 'Extração inteligente de dados',
        text:
          'Automatização da recolha, estruturação e tratamento de informação relevante para os processos da empresa.',
      },
      {
        title: 'Agentes para Diretores de Obra',
        text:
          'Apoio inteligente às atividades de acompanhamento, consulta e gestão de informação relacionada com obra.',
      },
      {
        title: 'Tratamento de DAAs',
        text:
          'Extração e processamento automatizado de informação, reduzindo tarefas manuais e melhorando a rastreabilidade.',
      },
      {
        title: 'Sales Agent',
        text:
          'Apoio às atividades comerciais, à preparação de informação e ao acompanhamento de oportunidades.',
      },
      {
        title: 'Dev Agent e AI Factory',
        text:
          'Criação de capacidades internas para desenvolver, integrar, gerir e evoluir soluções de inteligência artificial.',
      },
      {
        title: 'Capacitação das equipas',
        text:
          'Desenvolvimento das competências necessárias para adotar e utilizar as novas soluções nos processos de trabalho.',
      },
    ],
  },
  results: {
    title: 'Resultados esperados',
    items: [
      'Redução do tempo despendido em tarefas administrativas e operacionais.',
      'Maior automatização e eficiência dos processos internos.',
      'Melhoria da qualidade, disponibilidade e rastreabilidade da informação.',
      'Aumento da produtividade das equipas.',
      'Reforço da capacidade de inovação e adoção tecnológica da LOG.OSCON.',
    ],
  },
  supportNote:
    'Para mais informações sobre o Plano de Recuperação e Resiliência, consulte o portal',
  supportLinkLabel: 'Recuperar Portugal',
  supportHref: 'https://recuperarportugal.gov.pt/',
  disclaimer:
    'Financiado pela União Europeia — NextGenerationEU. No entanto, as opiniões expressas são apenas as dos autores e não refletem necessariamente as opiniões da União Europeia ou da Comissão Europeia. Nem a União Europeia nem a Comissão Europeia são responsáveis por essas opiniões.',
}

export const LOG_AI_EN = {
  seo: {
    title: 'log.AI project',
    description:
      'Information about LOG.OSCON’s log.AI project, supported by Portugal’s Recovery and Resilience Plan and funded by the European Union through NextGenerationEU.',
  },
  title: 'log.AI project',
  lead:
    'LOG.OSCON is delivering the log.AI project, a digital transformation initiative to integrate artificial intelligence into the company’s internal processes and business activities.',
  financing: {
    label: 'Project funding',
    alt:
      'PRR — Recovery and Resilience Plan, Portuguese Republic, and Funded by the European Union NextGenerationEU',
    text:
      'Project supported by the Recovery and Resilience Plan and funded by the European Union through NextGenerationEU.',
  },
  identification: {
    title: 'Project identification',
    items: [
      { label: 'Beneficiary', value: 'LOG.OSCON, LDA' },
      { label: 'Project number', value: '25286' },
      { label: 'Call', value: '03/C05-i14.01/2025' },
      { label: 'Investment', value: 'C05-i14.01\nBusiness Innovation' },
      { label: 'Eligible investment', value: '€148,406.80' },
      { label: 'Financial support', value: '€111,305.10' },
      { label: 'Funding rate', value: '75%' },
      { label: 'Implementation period', value: '01.01.2025\n31.12.2026' },
      { label: 'Managing entity', value: 'Banco Português de Fomento' },
    ],
  },
  description: {
    title: 'Description',
    paragraphs: [
      'The log.AI project aims to accelerate the adoption of artificial intelligence at LOG.OSCON by automating tasks, improving how information is processed and used, and strengthening the efficiency of operational, commercial and administrative processes.',
      'The initiative includes intelligent data extraction and AI agents integrated into the company’s processes and systems, together with training teams to use the new tools.',
    ],
  },
  objectives: {
    title: 'Objectives',
    items: [
      'Digitise and automate internal processes.',
      'Reduce the effort spent on manual and repetitive tasks.',
      'Implement intelligent data extraction and processing solutions.',
      'Develop AI agents to support operational, commercial and administrative teams.',
      'Improve productivity, information traceability and the organisation’s responsiveness.',
      'Strengthen internal skills in using and managing artificial intelligence solutions.',
    ],
  },
  workstreams: {
    title: 'Areas of intervention',
    items: [
      {
        title: 'Intelligent data extraction',
        text:
          'Automating the collection, structuring and processing of information relevant to the company’s processes.',
      },
      {
        title: 'Agents for project directors',
        text:
          'Intelligent support for monitoring, querying and managing project-related information.',
      },
      {
        title: 'DAA processing',
        text:
          'Automated extraction and processing of information, reducing manual work and improving traceability.',
      },
      {
        title: 'Sales Agent',
        text:
          'Support for commercial activity, preparing information and following up on opportunities.',
      },
      {
        title: 'Dev Agent and AI Factory',
        text:
          'Building internal capacity to develop, integrate, manage and evolve artificial intelligence solutions.',
      },
      {
        title: 'Team upskilling',
        text:
          'Developing the skills needed to adopt and use the new solutions in day-to-day work.',
      },
    ],
  },
  results: {
    title: 'Expected results',
    items: [
      'Less time spent on administrative and operational tasks.',
      'Greater automation and efficiency of internal processes.',
      'Better quality, availability and traceability of information.',
      'Higher team productivity.',
      'Stronger innovation and technology adoption at LOG.OSCON.',
    ],
  },
  supportNote:
    'For more information on the Recovery and Resilience Plan, see',
  supportLinkLabel: 'Recuperar Portugal',
  supportHref: 'https://recuperarportugal.gov.pt/',
  disclaimer:
    'Funded by the European Union — NextGenerationEU. Views and opinions expressed are those of the authors only and do not necessarily reflect those of the European Union or the European Commission. Neither the European Union nor the European Commission can be held responsible for them.',
}
